import { isMobile } from "react-device-detect";
import { BiUndo } from "react-icons/bi";
import { HiChevronLeft } from "react-icons/hi";
import { MdCheck, MdClose } from "react-icons/md";
import { useDialog } from "src/contexts/dialog-context";
import MutableIcon from "../../../../../../components/mutable-icon";
import {
  WorkoutIcon,
  WorkoutTypeString,
} from "../../../../../fithub-shared/interfaces/workout";
import { Header, Labels, ModText } from "./styles";

interface HeaderProps {
  handleSave?: () => Promise<void>;
  title: string;
  type: number;
  onRename: (t: string) => void;
  unselect: () => void;
  undo?: () => void;
}

export const WorkoutHeader = (props: HeaderProps) => {
  const dialog = useDialog();

  function UndoChanges() {
    if (props.undo === undefined) return;

    dialog.openDialog(
      "Desfazer Alterações",
      "Esta ação irá descartar quaisquer modificações feitas neste treino para este dispositivo!\n\nGostaria de continuar?",
      props.undo,
    );
  }

  const CacheInfo = () => {
    if (isMobile || window.screen.width < 768) {
      return (
        <>
          {props.undo ? (
            <MdClose color="var(--primary)" size={12} />
          ) : (
            <MdCheck size={12} />
          )}
        </>
      );
    } else {
      return <>{props.undo ? "Modificado" : "Sem Modificações"}</>;
    }
  };

  return (
    <Header className="flex">
      <div className="flex items-center">
        <MutableIcon icon={HiChevronLeft} size={40} onClick={props.unselect} />
        <MutableIcon icon={WorkoutIcon(props.type)} size={28} color={"#0008"} />
        <Labels>
          <input
            className="bg-transparent p-0 text-base font-bold text-zinc-700 underline decoration-zinc-700 shadow-none focus:text-black"
            defaultValue={props.title}
            placeholder="Titulo do Treino..."
            onBlur={(e) => props.onRename(e.target.value)}
          />

          <h5 className="text-xs font-semibold uppercase">
            {WorkoutTypeString(props.type)}
          </h5>
        </Labels>
      </div>

      <div className="flex flex-row" style={{ alignItems: "center" }}>
        <div className="flex flex-row" style={{ alignItems: "center" }}>
          <ModText modified={Boolean(props.undo)} onClick={UndoChanges}>
            {props.undo && (
              <>
                <BiUndo size={20} />

                <span style={{ width: 4 }} />
              </>
            )}
            <CacheInfo />
          </ModText>

          <button
            disabled={Boolean(props.handleSave) === false}
            className={`ml-4 flex items-center justify-center rounded-md ${props.handleSave ? "bg-green-700 text-white" : "bg-zinc-700 text-white"} font-base h-8 px-2`}
            onClick={props.handleSave}
          >
            {props.handleSave ? "SALVAR" : <MdCheck />}
          </button>
        </div>
      </div>
    </Header>
  );
};

export default WorkoutHeader;
